"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundLayer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var lodash_1 = __importDefault(require("lodash"));
var timeUtils_1 = require("../utils/timeUtils");
var Marker_1 = require("./Marker");
var HighlightedInterval_1 = require("./HighlightedInterval");
var moment_1 = __importDefault(require("moment"));
/**
 * @extends React.Component<BackgroundLayer.propTypes>
 */
var BackgroundLayer = /** @class */ (function (_super) {
    __extends(BackgroundLayer, _super);
    function BackgroundLayer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { verticalLines: [], shouldUpdate: false, weekends: [] };
        _this.calculateHorizontalPosition = _this.calculateHorizontalPosition.bind(_this);
        return _this;
    }
    BackgroundLayer.prototype.componentDidMount = function () {
        this.calculateHighlightedWeekends();
    };
    BackgroundLayer.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.height !== prevProps.height ||
            this.props.width !== prevProps.width ||
            !this.props.startDateTimeline.isSame(prevProps.startDateTimeline) ||
            !this.props.endDateTimeline.isSame(prevProps.endDateTimeline)) {
            this.calculateHighlightedWeekends();
            this.setState({ shouldUpdate: true });
            return;
        }
        if (this.state.shouldUpdate) {
            this.setState({ shouldUpdate: false });
        }
    };
    /**
     * It calculates the horizontal position (left and width in pixels) of an element from the time positions (start, end).
     * @param { object | number } start
     * @param { object | number } end
     * @returns { object } left position and width in pixels
     */
    BackgroundLayer.prototype.calculateHorizontalPosition = function (start, end) {
        var intervalMillis = this.props.endDateTimeline.diff(this.props.startDateTimeline, 'milliseconds');
        var pixelsPerMillis = (this.props.width - this.props.leftOffset) / intervalMillis;
        var startAsMoment = (0, timeUtils_1.convertDateToMoment)(start);
        var endAsMoment = (0, timeUtils_1.convertDateToMoment)(end);
        if (endAsMoment.isBefore(this.props.startDateTimeline) || startAsMoment.isAfter(this.props.endDateTimeline)) {
            return {};
        }
        var offset = startAsMoment.diff(this.props.startDateTimeline, 'milliseconds');
        var duration = (endAsMoment <= this.props.endDateTimeline ? endAsMoment : this.props.endDateTimeline).diff(startAsMoment, 'milliseconds');
        var left = this.props.leftOffset + offset * pixelsPerMillis;
        var width = Math.round(duration * pixelsPerMillis);
        return { left: left, width: width };
    };
    /**
     * Calculates the weekend intervals for the timeline displayed interval (`startDateTimeline` - `endDateTimeline`).
     */
    BackgroundLayer.prototype.calculateHighlightedWeekends = function () {
        var weekends = [];
        if (!this.props.highlightWeekends) {
            return;
        }
        var weekendStartDate = this.props.startDateTimeline.clone().startOf('day');
        var weekendEndDate = null;
        // find first weekend day
        while (weekendStartDate.isoWeekday() !== 6 && weekendStartDate.isoWeekday() !== 7) {
            weekendStartDate = weekendStartDate.add(1, 'days');
        }
        // compute all the weekends in the interval
        while (weekendStartDate < this.props.endDateTimeline) {
            if (weekendStartDate.isoWeekday() === 7) {
                weekendEndDate = weekendStartDate.clone().add(1, 'days');
            }
            else {
                weekendEndDate = weekendStartDate.clone().add(2, 'days');
            }
            weekends.push({
                start: weekendStartDate,
                end: weekendEndDate,
                className: "rct9k-background-layer-highlight-weekends ".concat(this.props.highlightWeekendsClassName)
            });
            // go to the next weekend
            weekendStartDate = weekendEndDate.clone().add(5, 'days');
        }
        this.setState({ weekends: weekends });
    };
    BackgroundLayer.prototype.renderHighlightedWeekends = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: this.props.highlightWeekends &&
                this.state.weekends.map(function (weekend, index) {
                    return ((0, jsx_runtime_1.jsx)(HighlightedInterval_1.HighlightedInterval, { id: index, start: weekend.start, end: weekend.end, className: weekend.className, style: _this.props.highlightWeekendsStyle, top: _this.props.topOffset, height: _this.props.height, shouldUpdate: _this.state.shouldUpdate, calculateHorizontalPosition: _this.calculateHorizontalPosition }, index));
                }) }));
    };
    BackgroundLayer.prototype.renderCustomComponents = function (components) {
        var _this = this;
        var weekendsCount = this.props.highlightWeekends ? this.state.weekends.length : 0;
        return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: components.map(function (component, index) {
                return react_1.default.cloneElement(component, {
                    key: index,
                    id: weekendsCount + index,
                    height: _this.props.height,
                    top: _this.props.topOffset,
                    shouldUpdate: _this.state.shouldUpdate,
                    calculateHorizontalPosition: _this.calculateHorizontalPosition
                });
            }) }));
    };
    BackgroundLayer.prototype.renderVerticalGrid = function () {
        var _this = this;
        var _a = this.props, verticalGrid = _a.verticalGrid, topOffset = _a.topOffset, height = _a.height, leftOffset = _a.leftOffset, width = _a.width, verticalGridLines = _a.verticalGridLines, verticalGridClassName = _a.verticalGridClassName;
        return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: verticalGrid && verticalGridLines && ((0, jsx_runtime_1.jsx)("div", { className: "rct9k-background-layer-vertical-grid", style: { top: topOffset, height: height, left: leftOffset, width: width - leftOffset }, children: verticalGridLines.map(function (verticalLine, index) {
                    return ((0, jsx_runtime_1.jsx)("span", { className: "rct9k-background-layer-vertical-line ".concat(verticalGridClassName), style: __assign(__assign({}, _this.props.verticalGridStyle), { width: verticalLine.size }) }, index));
                }) })) }));
    };
    BackgroundLayer.prototype.renderNowMarker = function () {
        var _a = this.props, nowMarker = _a.nowMarker, height = _a.height, topOffset = _a.topOffset, nowMarkerClassName = _a.nowMarkerClassName;
        var currentDate = (0, moment_1.default)();
        var overlappsDisplayedInterval = this.props.startDateTimeline.isSameOrBefore(currentDate) && this.props.endDateTimeline.isSameOrAfter(currentDate);
        return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: nowMarker && overlappsDisplayedInterval && ((0, jsx_runtime_1.jsx)(Marker_1.Marker, { date: currentDate, top: 0, height: height + topOffset, shouldUpdate: this.state.shouldUpdate, calculateHorizontalPosition: this.calculateHorizontalPosition, className: "rct9k-background-layer-now-marker ".concat(nowMarkerClassName), style: this.props.nowMarkerStyle })) }));
    };
    BackgroundLayer.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "rct9k-background-layer-wrapper", children: (0, jsx_runtime_1.jsxs)("div", { className: "rct9k-background-layer", children: [this.renderHighlightedWeekends(), this.renderCustomComponents(this.props.highlightedIntervals), this.renderNowMarker(), this.renderCustomComponents(this.props.markers), this.renderVerticalGrid()] }) }));
    };
    BackgroundLayer.propTypes = {
        /**
         * If `true`, it highlights the weekends.
         *
         * @type { boolean }
         */
        highlightWeekends: prop_types_1.default.bool,
        /**
         * Custom class name for highlighting the weekends.
         *
         * NOTE: No need to provide this; because it has a default class. If a custom class is provided, `!important` should be used to override properties from the default class.
         *
         * @type { string }
         */
        highlightWeekendsClassName: prop_types_1.default.string,
        /**
         * Custom style for highlighting the weekends.
         *
         * NOTE: No need to provide this; because it has a default class.
         *
         * @type { object }
         */
        highlightWeekendsStyle: prop_types_1.default.object,
        /**
         * If `true`, it draws a marker (vertical line) that indicates the current time.
         *
         * @type { boolean }
         */
        nowMarker: prop_types_1.default.bool,
        /**
         * Custom class name for now marker.
         *
         * NOTE: No need to provide this; because it has a default class. If a custom class is provided, `!important` should be used to override properties from the default class.
         *
         * @type { string }
         */
        nowMarkerClassName: prop_types_1.default.string,
        /**
         * Custom style for now marker.
         *
         * NOTE: No need to provide this; because it has a default class.
         *
         * @type { object }
         */
        nowMarkerStyle: prop_types_1.default.object,
        /**
         * If `true`, it draws vertical lines, according to the intervals defined by the bottom `Timebar`.
         *
         * @type { boolean }
         */
        verticalGrid: prop_types_1.default.bool,
        /**
         * Custom class name for vertical grid.
         *
         * NOTE: No need to provide this; because it has a default class. If a custom class is provided, `!important` should be used to override properties from the default class.
         *
         * @type { string }
         */
        verticalGridClassName: prop_types_1.default.string,
        /**
         * Custom style for vertical grid.
         *
         * NOTE: No need to provide this; because it has a default class.
         *
         * @type { object }
         */
        verticalGridStyle: prop_types_1.default.object,
        /**
         * @type { Array.<JSX.Element> }
         */
        markers: prop_types_1.default.arrayOf(prop_types_1.default.object),
        /**
         * @type { Array.<JSX.Element> }
         */
        highlightedIntervals: prop_types_1.default.arrayOf(prop_types_1.default.object),
        /**
         * Internal (passed by parent). Start of the timeline display interval, as date (moment object).
         *
         * @type { object }
         */
        startDateTimeline: prop_types_1.default.object,
        /**
         * Internal (passed by parent). End of the timeline display interval, as date (moment object).
         *
         * @type { object }
         */
        endDateTimeline: prop_types_1.default.object,
        /**
         * Internal (passed by parent). The height of the background layer.
         *
         * @type { number }
         */
        height: prop_types_1.default.number,
        /**
         * Internal (passed by parent). The position of the top edge of background layer.
         *
         * @type { number }
         */
        topOffset: prop_types_1.default.number,
        /**
         * Internal (passed by parent). Total width of the timeline.
         *
         * @type { number }
         */
        width: prop_types_1.default.number,
        /**
         * Internal (passed by parent). The position of the left edge of background layer.
         *
         * @type { number }
         */
        leftOffset: prop_types_1.default.number,
        /**
         * Internal (passed by parent). The vertical lines of the grid are already calculated by `Timerbar`.
         *
         * @type { Array.<object>}
         */
        verticalGridLines: prop_types_1.default.arrayOf(prop_types_1.default.object)
    };
    BackgroundLayer.defaultProps = {
        highlightWeekends: false,
        highlightWeekendsClassName: undefined,
        highlightWeekendsStyle: undefined,
        nowMarker: false,
        nowMarkerClassName: undefined,
        nowMarkerStyle: undefined,
        verticalGrid: false,
        verticalGridClassName: undefined,
        verticalGridStyle: undefined,
        verticalGridLines: [],
        markers: [],
        highlightedIntervals: [],
        height: undefined,
        topOffset: undefined,
        width: undefined,
        leftOffset: undefined,
        startDateTimeline: undefined,
        endDateTimeline: undefined
    };
    return BackgroundLayer;
}(react_1.default.Component));
exports.BackgroundLayer = BackgroundLayer;
//# sourceMappingURL=BackgroundLayer.js.map